export const clone = <T extends unknown>(ref: T): T => JSON.parse(JSON.stringify(ref))
